import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { AppConfig } from '../services/app_config';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(public authService: AuthService, private router: Router, private toastr: ToastrService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.authService.getJwtToken()) {
      request = this.addToken(request, this.authService.getJwtToken());
    }
    
    // request = request.clone({
    //   setHeaders: {
    //     'X-Custom-Header': 'CustomHeaderValue',
    //     'appdomainname': 'skillflodemo.sifylivewire.com',
    //     'apporigin': 'https://skillflodemo.sifylivewire.com/',  // Replace with your domain name
    //     'Content-Type': 'application/json',
    //     ...(this.authService.getJwtToken() && {
    //       Authorization: `Bearer ${this.authService.getJwtToken()}`
    //     })
    //   }
    // });

    return next.handle(request).pipe(catchError((error) => {
      if (error instanceof HttpErrorResponse && (error.status === 307 || error.status === 401 )) {
        // || error.status === 400
        return this.handle401Error(request, next);
      } else if (error instanceof HttpErrorResponse && (error.status === 403)) {
        return this.handle403Error(request, next);
      } else {
        return throwError(error);
      }
    }));
  }

  private addToken(request: HttpRequest<any>, token: string) {
    return request.clone({
      setHeaders: {
        'x-auth-token': `${token}`,
        'x-session-id': (JSON.parse(localStorage.loginInfonetApp).sessionId) || '',
        'isTenant': 'false'
        //'origin': AppConfig.IP_Address
      }
    });
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);
      return this.authService.refreshToken().pipe(
        switchMap((token: any) => {
          this.isRefreshing = false;
          this.refreshTokenSubject.next(token.jwt);
          return next.handle(this.addToken(request, token.jwt));
        }));

    } else {
      localStorage.removeItem("loginInfonetApp");
      localStorage.removeItem("JWT_TOKEN");
      localStorage.removeItem("UserInfo");
      localStorage.removeItem("refreshToken");
      this.router.navigate(['./login']);
      this.toastr.error('Session Expired', '');
    }
  }

  // private handle403Error(request: HttpRequest<any>, next: HttpHandler) {
  //     this.router.navigate(['./login']);
  //     this.toastr.error('Please login again', 'Unauthorized Access');
  //     return throwError('Unauthorized Access');
  // }
    private handle403Error(request: HttpRequest<any>, next: HttpHandler) {
    localStorage.clear();
    this.router.navigate(['./login']);
    this.toastr.error('Please login again', 'Unauthorized Access');
    return throwError('Unauthorized Access');
  }
}